"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/technologySection.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TechnologySectionTechnologyThreesItem = {
    key: Key | null | undefined;
    /** Detected variants: "technology-item-three" | "technology-item-three mb-0" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/tech-icon-1.svg" | "/Templates/Doccure/img/icons/tech-icon-2.svg" | "/Templates/Doccure/img/icons/tech-icon-3.svg" | "/Templates/Doccure/img/icons/tech-icon-4.svg" */
    src: string;
    /** Detected variants: "Laser Dentistry" | "Digital X-Rays" | "3D Intraoral Scanning" | "Same Day Crowns" */
    h30Text: ReactNode;
    /** Detected variants: "Minimally invasive laser technology for painless procedures, faster healing, and precise treatments." | "90% less radiation than traditional X-rays with instant, high-resolution imaging for accurate diagnosis." | "Advanced 3D scanning eliminates uncomfortable impressions while providing detailed digital models." | "CEREC technology allows us to design, mill, and place custom crowns in a single appointment." */
    p0Text: ReactNode;
    /** Detected variants: "avatar flex-shrink-0" */
    div0ClassName?: string;
    /** Detected variants: "tech-icon" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "technology-details" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeThreeTechnologySectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TechnologySectionTechnologyThreesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TechnologySectionTechnologyThreesItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0ClassName?: string;
    /** Default: "fade-up" */
    sectionDiv0Div0Div0Div0DivDataAos?: string;
    /** Default: "Cutting Edge Technology" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "We invest in the latest dental technology to provide safer, faster, and more comfortable treatments" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "elemet" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/technology-element-1.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "elemet" */
    sectionDiv0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/tech-elemet-1.png" */
    sectionDiv0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    sectionDiv0Div1Div0Button0ButtonDataFancybox?: string;
    sectionDiv0Div1Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "technologies" */
    sectionDiv0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/category/technologies-img.jpg" */
    sectionDiv0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "tech-bg-01" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/tech-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "tech-bg-02" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/tech-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    technologySectionTechnologyThrees: TechnologySectionTechnologyThreesItem[];
    technologySectionTechnologyThreesItemWrapper?: (item: TechnologySectionTechnologyThreesItem, content: ReactNode) => ReactNode;
    technologySectionTechnologyThreesRenderer?: (defaultNode: ReactNode) => ReactNode;
    technologySectionTechnologyThreesImageVisible?: boolean;
    technologySectionTechnologyThreesImageRenderer?: (item: TechnologySectionTechnologyThreesItem, defaultNode: ReactNode) => ReactNode;
    technologySectionTechnologyThreesH3Visible?: boolean;
    technologySectionTechnologyThreesH3Renderer?: (item: TechnologySectionTechnologyThreesItem, defaultNode: ReactNode) => ReactNode;
    technologySectionTechnologyThreesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TechnologySectionTechnologyThreesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    technologySectionTechnologyThreesH3Props?: Partial<ComponentProps<"h3">> | ((item: TechnologySectionTechnologyThreesItem) => Partial<ComponentProps<"h3">>);
};

const HomeThreeTechnologySectionGenerated: FC<HomeThreeTechnologySectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0DivDataAos = "fade-up",
    sectionDiv0Div0Div0Div0H20H2Text = "Cutting Edge Technology",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0P0PText = "We invest in the latest dental technology to provide safer, faster, and more comfortable treatments",
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "elemet",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/technology-element-1.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath1ImageAlt = "elemet",
    sectionDiv0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/tech-elemet-1.png",
    sectionDiv0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div1Div0Button0ButtonDataFancybox = "",
    sectionDiv0Div1Div0Button0ButtonVisible,
    sectionDiv0Div1Div0Button0ButtonRenderer,
    sectionDiv0Div1Div0Button0ButtonProps,
    sectionDiv0Div1Div0ImageWithBasePath0ImageAlt = "technologies",
    sectionDiv0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/category/technologies-img.jpg",
    sectionDiv0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "tech-bg-01",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/tech-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "tech-bg-02",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/tech-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0ClassName,
    technologySectionTechnologyThrees,
    technologySectionTechnologyThreesItemWrapper,
    technologySectionTechnologyThreesRenderer,
    technologySectionTechnologyThreesImageVisible,
    technologySectionTechnologyThreesImageRenderer,
    technologySectionTechnologyThreesH3Visible,
    technologySectionTechnologyThreesH3Renderer,
    technologySectionTechnologyThreesImageProps,
    technologySectionTechnologyThreesH3Props,
}) => {
    return (
        <>
            <section className="technology-section-three position-relative">
                <div className={sectionDiv0ClassName ?? "row g-0 w-100"}>
                    <div className="col-lg-6 left-side">
                        <div className="container">
                            <div className="section-header section-header-three aos" data-aos={sectionDiv0Div0Div0Div0DivDataAos}>
                                {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                                ))}
                                <p className="subtitle">{sectionDiv0Div0Div0Div0P0PText}</p>
                            </div>
                            {renderCollectionNode(
                                technologySectionTechnologyThrees,
                                (item: TechnologySectionTechnologyThreesItem) => (
                                    <div className={item.className} key={item.key}>
                                        <div className={item.div0ClassName ?? "avatar flex-shrink-0"}>
                                            {renderItemNode(technologySectionTechnologyThreesImageVisible, technologySectionTechnologyThreesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "tech-icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof technologySectionTechnologyThreesImageProps === "function" ? technologySectionTechnologyThreesImageProps(item) : (technologySectionTechnologyThreesImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "technology-details"}>
                                            {renderItemNode(technologySectionTechnologyThreesH3Visible, technologySectionTechnologyThreesH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof technologySectionTechnologyThreesH3Props === "function" ? technologySectionTechnologyThreesH3Props(item) : (technologySectionTechnologyThreesH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p>{item.p0Text}</p>
                                        </div>
                                    </div>
                                ),
                                technologySectionTechnologyThreesItemWrapper,
                                technologySectionTechnologyThreesRenderer
                            )}
                        </div>
                        {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {renderNode(sectionDiv0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0ImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionDiv0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="col-lg-6">
                        <div className="tech-img">
                            {renderNode(sectionDiv0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div1Div0Button0ButtonVisible, sectionDiv0Div1Div0Button0ButtonRenderer, (
                                <button className="play-btn" data-fancybox={sectionDiv0Div1Div0Button0ButtonDataFancybox} {...(sectionDiv0Div1Div0Button0ButtonProps ?? {})}>
                                    <i className="isax isax-play" />
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeThreeTechnologySectionGenerated;
